module.exports = __webpack_public_path__ + "static/media/RewardsV2.ca09a0cd.png";